import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'sonner';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './index.css';
import { initOneSignal } from './lib/onesignal';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
});

// ✅ REGISTRAR SERVICE WORKER PARA ONESIGNAL E PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/OneSignalSDKWorker.js');
      console.log('✅ Service Worker registrado:', registration.scope);

      // ✅ INICIALIZAR ONESIGNAL APÓS SW REGISTRADO
      setTimeout(() => {
        initOneSignal();
      }, 1500);

    } catch (error) {
      console.error('❌ Erro no Service Worker:', error);
    }
  });
}

// ✅ REMOVIDO React.StrictMode - evita dupla execução no React 18
ReactDOM.createRoot(document.getElementById('root')).render(
  <QueryClientProvider client={queryClient}>
    <App />
    <Toaster position="top-right" richColors />
  </QueryClientProvider>
);